import { Card, CardActionArea, Box, Typography, Chip } from '@material-ui/core';
import { TrendingUp, TrendingDown } from '@material-ui/icons';

const MetricCard = ({ data, onClick, hasChildren }) => {
  const Icon = data.icon;
  const isUp = data.trend === 'up';

  const imageHalf = data.image ? (
    <Box
      sx={{
        flex: 1,
        minHeight: { xs: 200, sm: 220 },
        backgroundImage: `url(${data.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(135deg, rgba(12,89,53,0.35) 0%, rgba(0,0,0,0.15) 100%)'
        }
      }}
    />
  ) : (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'primary.main',
        p: 4,
        minHeight: { xs: 160, sm: 180 }
      }}
    >
      <Icon sx={{ fontSize: 64, color: 'primary.contrastText', opacity: 0.9 }} />
    </Box>
  );

  const content = (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {imageHalf}
      <Box
        sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 3, gap: 0.5 }}
      >
        <Typography variant="subtitle2" color="text.secondary">
          {data.title}
        </Typography>
        <Typography variant="h4" color="text.primary" sx={{ fontWeight: 700 }}>
          {data.value}
        </Typography>
        <Chip
          icon={isUp ? <TrendingUp fontSize="small" /> : <TrendingDown fontSize="small" />}
          label={data.trendValue}
          size="small"
          sx={{
            alignSelf: 'flex-start',
            mt: 0.5,
            fontWeight: 700,
            bgcolor: isUp ? 'success.main' : 'error.main',
            color: '#fff',
            '& .MuiChip-icon': { color: '#fff' }
          }}
        />
        {hasChildren && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, opacity: 0.6 }}>
            Click to explore →
          </Typography>
        )}
      </Box>
    </Box>
  );

  if (hasChildren && onClick) {
    return (
      <Card elevation={2}>
        <CardActionArea onClick={onClick}>{content}</CardActionArea>
      </Card>
    );
  }

  return <Card elevation={2}>{content}</Card>;
};

export default MetricCard;
